import { LoadingContext } from "context/LoadingContext";
import { useContext, useEffect } from "react";
import { useQuery } from "react-query";
import { http } from "shared/util/http";
export interface QueryOptions {
  key: any[];
  url: string;
  params?: object;
  enabled?: boolean;
  config?: object;
  pathVariables?: string;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
  onFinaly?: () => void;
}

function useFetch<T>(options: QueryOptions) {
  const { reservarCarregamento } = useContext(LoadingContext);

  const consulta = useQuery({
    queryKey: options.key,
    queryFn: async () => {
      const response = await http.get<T>(
        `${options.url}${options.pathVariables ? "/" + options.pathVariables : ""}`,
        options.params
      );
      return response.data;
    },

    onSuccess: options.onSuccess,
    onError: options.onError,
    onSettled: () => {
      if (options.onFinaly) {
        options.onFinaly();
      }
    },
    enabled: options.enabled,
    ...options.config,
  });

  // O overlay acompanha o `isFetching` em vez de ser ligado dentro da `queryFn` e desligado
  // no `onSettled`: no react-query v3 os callbacks são do observer, e desmontar o
  // componente antes da resposta destrói o observer — o `onSettled` nunca rodava e o
  // overlay ficava ligado sobre o sistema inteiro. Aqui a liberação é cleanup de efeito,
  // então acontece também na desmontagem.
  useEffect(() => {
    if (!consulta.isFetching) return;
    return reservarCarregamento();
  }, [consulta.isFetching, reservarCarregamento]);

  return consulta;
}
export default useFetch;
